import { MuiClassCollection } from "../../../foundations/mui-class-collection.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import MuiAccordion from "../../../../node_modules/@mui/material/Accordion/Accordion.es.js";
import MuiAccordionSummary from "../../../../node_modules/@mui/material/AccordionSummary/AccordionSummary.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
const MuiAccordionSummaryContentContainer = styled("div")({
  display: Displaying.flex,
  justifyContent: Alignment.spaceBetween,
  width: "100%",
  alignItems: Alignment.center
});
const ContainerWithMarginRight = styled("div")({
  marginRight: Spacing["500"],
  display: Displaying.inherit,
  alignItems: Alignment.center
});
const ContainerWithTopSpacing = styled("div")({
  marginTop: Spacing["250"],
  display: Displaying.inherit,
  alignItems: Alignment.center
});
const EndItemsContainer = styled("div", styledOptions)(({
  shouldBeExpandable
}) => ({
  display: Displaying.flex,
  alignItems: Alignment.center,
  pointerEvents: "auto",
  marginRight: shouldBeExpandable ? Spacing["500"] : Spacing["0"]
}));
const MuiAccordionContainer = styled(MuiAccordion, styledOptions)(({
  isMobile
}) => ({
  padding: isMobile ? `${Spacing["750"]} ${Spacing["1000"]}` : `${Spacing["500"]} ${Spacing["1500"]}`
}));
const MuiAccordionSummaryContainer = styled(MuiAccordionSummary, styledOptions)(({
  isMobile,
  shouldBeExpandable
}) => ({
  pointerEvents: shouldBeExpandable ? Displaying.initial : Displaying.none,
  ".MuiAccordionSummary-content": {
    [`&.${MuiClassCollection.expanded}`]: {
      margin: isMobile ? `${Spacing["500"]} 0` : Displaying.inherit
    }
  }
}));
export {
  ContainerWithMarginRight,
  ContainerWithTopSpacing,
  EndItemsContainer,
  MuiAccordionContainer,
  MuiAccordionSummaryContainer,
  MuiAccordionSummaryContentContainer
};
//# sourceMappingURL=components.es.js.map
